import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import { Switch } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import { CardContent, Divider } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import MailIcon from '@material-ui/icons/Mail'
import ContactPhone from '@material-ui/icons/ContactPhone'
import Person from '@material-ui/icons/Person'
import LocationOn from '@material-ui/icons/LocationOn'
import LocationCity from '@material-ui/icons/LocationCity'
import Business from '@material-ui/icons/Business'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

import Subscriptions from './Subscriptions'
import { PrivateRoute } from '../../Router'
import SubscriptionForm from './SubscriptionForm'
import getLoginId from '../../../utils/getLoginId'
import fetchClientPublicIp from '../../../utils/fetchClientPublicIp'

const GET_PARTNER = gql`
  query partnerDetail($loginId: Int) {
    partnerDetail(loginId: $loginId) {
      id
      businessName
      contactPerson
      address
      city
      state {
        name
      }
      country {
        name
      }
      email
      contactNumber
      login {
        loginId
      }
      deviceCount {
        totalDevices
        inStockDevices
        assignedToClientDevices
        registeredDevices
      }
      simCount {
        totalSims
        inStockSims
        assignedToClientSims
        registeredSims
      }
    }
  }
`

const GET_LOGIN_TOKEN = gql`
  query getClientLoginToken(
    $clientid: Int!
    $clientIp: String
    $source: String
    $performedByLoginId: Int
    $performedByUsername: String
  ) {
    getClientLoginToken(
      id: $clientid
      clientIp: $clientIp
      source: $source
      performedByLoginId: $performedByLoginId
      performedByUsername: $performedByUsername
    ) {
      token
    }
  }
`
const GET_PARTNER_DOMAIN = gql`
  query getPartnerDomainConfig($loginId: Int!) {
    getPartnerDomainConfig(loginId: $loginId)
  }
`

const styles = theme => ({
  gridItem: {
    padding: theme.spacing.unit * 2
  },
  containerPadding: {
    padding: theme.spacing.unit
  },
  gridItemHorizontal: {
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,

    '&:first-child': {
      paddingLeft: 0
    },
    '&:last-child': {
      paddingRight: 0
    }
  },
  gridItemVertical: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,

    '&:first-child': {
      paddingTop: 0
    },
    '&:last-child': {
      paddingBottom: 0
    }
  },
  cardItemIcon: {
    margin: theme.spacing.unit
  },
  paper: {
    padding: theme.spacing.unit * 1,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  button: {
    margin: theme.spacing.unit
  },
  input: {
    display: 'none'
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center'
  },
  valueNumber: {
    color: 'red',
    fontSize: '1.2rem'
  }
})

class PartnerView extends Component {
  constructor(props) {
    super(props)
    this.loginId = parseInt(this.props.match.params.loginId, 10)
  }

  editCustomer = loginId => e => {
    console.log('edit')
    this.props.history.push({
      pathname: '/home/partner/edit/' + this.loginId
    })
  }

  handleRegistration = e => {
    this.props.history.push({
      pathname: '/home/VehicleRegistration'
    })
  }

  showSubscription = subscriptionId => e => {
    this.props.history.push({
      pathname:
        '/home/subscriptions/view/' + this.loginId + '/' + subscriptionId
    })
  }

  allCustomer = e => {
    this.props.history.push({
      pathname: e,
      state: {
        from: this.props.location.pathname
      }
    })
  }

  createNewSubscription = e => {
    this.props.history.push({
      pathname: '/home/subscriptions/new/' + this.loginId
    })
  }

  loginCustomer = clientId => async () => {
    const clientIp = await fetchClientPublicIp()
    const { data } = await this.props.client.query({
      query: GET_LOGIN_TOKEN,
      variables: {
        clientid: clientId,
        clientIp,
        source: 'admin-frontend',
        performedByLoginId: getLoginId(),
        performedByUsername: localStorage.getItem('username')
      }
    })
    if (data) {
      const { data: domain } = await this.props.client.query({
        query: GET_PARTNER_DOMAIN,
        variables: {
          loginId: clientId
        }
      })
      let clienturl = `https://preview-devba.aquilatrack.com/?token=${
        data.getClientLoginToken.token
      }`
      let win = window.open(clienturl, '_blank')
      win.focus()
    }
  }

  render() {
    const { classes } = this.props

    return (
      <Query
        query={GET_PARTNER}
        variables={{
          loginId: this.loginId
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data }) => {
          if (loading) return 'Loading...'
          if (error) return `Error!: ${error}`
          // console.log(' partner detail', data)

          return (
            <Fragment>
              {data && (
                <Grid container>
                  <Grid item xs={12}>
                    <Grid container justify="space-between">
                      <Grid item className={classes.gridItemHorizontal}>
                        <Button
                          variant="outlined"
                          color="secondary"
                          className={classes.button}
                          onClick={() => this.props.history.goBack()}
                        >
                          <ArrowBackIcon className={classes.iconSmall} />
                        </Button>
                      </Grid>

                      <Grid item className={classes.gridItemHorizontal}>
                        <Button
                          color="secondary"
                          variant="raised"
                          className={classes.button}
                          onClick={this.handleRegistration}
                        >
                          Assign Devices
                        </Button>

                        <Button
                          variant="outlined"
                          color="primary"
                          className={classes.button}
                          // onClick={() =>
                          //   this.editCustomer(data.partnerDetail.login.loginId)
                          // }
                          onClick={this.editCustomer(
                            data.partnerDetail.login.loginId
                          )}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          className={classes.button}
                          onClick={this.loginCustomer(
                            data.partnerDetail.login.loginId
                          )}
                        >
                          Login Preview
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container className={classes.containerPadding}>
                      <Grid
                        item
                        xs={12}
                        md={8}
                        className={classes.gridItemHorizontal}
                      >
                        <Card className={classes.card}>
                          <CardContent>
                            <Grid container>
                              <Grid item xs={12}>
                                <Grid container alignItems="center">
                                  <Grid item className={classes.alignCenter}>
                                    <Business
                                      color="primary"
                                      className={classes.cardItemIcon}
                                    />
                                  </Grid>

                                  <Grid item>
                                    <Typography
                                      variant="headline"
                                      color="primary"
                                    >
                                      {data.partnerDetail.businessName}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <Grid container alignItems="center">
                                  <Grid item className={classes.alignCenter}>
                                    <Person
                                      color="primary"
                                      className={classes.cardItemIcon}
                                    />
                                  </Grid>

                                  <Grid item>
                                    <Typography color="primary">
                                      {data.partnerDetail.contactPerson}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <Grid container alignItems="center">
                                  <Grid item className={classes.alignCenter}>
                                    <LocationOn
                                      color="primary"
                                      className={classes.cardItemIcon}
                                    />
                                  </Grid>

                                  <Grid item>
                                    <Typography color="primary">
                                      {data.partnerDetail.address}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <Grid container alignItems="center">
                                  <Grid item className={classes.alignCenter}>
                                    <LocationCity
                                      color="primary"
                                      className={classes.cardItemIcon}
                                    />
                                  </Grid>

                                  <Grid item>
                                    <Typography color="primary">
                                      {`${data.partnerDetail.city} ${
                                        data.partnerDetail.state.name
                                      } ${data.partnerDetail.country.name}`}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <Grid container alignItems="center">
                                  <Grid item className={classes.alignCenter}>
                                    <MailIcon
                                      color="primary"
                                      className={classes.cardItemIcon}
                                    />
                                  </Grid>

                                  <Grid item>
                                    <Typography color="primary">
                                      {data.partnerDetail.email}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <Grid container alignItems="center">
                                  <Grid item className={classes.alignCenter}>
                                    <ContactPhone
                                      color="primary"
                                      className={classes.cardItemIcon}
                                    />
                                  </Grid>

                                  <Grid item>
                                    <Typography color="primary">
                                      {data.partnerDetail.contactNumber}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={2}
                        className={classes.gridItemHorizontal}
                      >
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            className={classes.gridItemVertical}
                          >
                            <Paper className={classes.paper}>
                              <span className={classes.valueNumber}>
                                {data.partnerDetail.deviceCount.totalDevices}
                              </span>
                              <br />
                              <span>Total Devices</span>
                            </Paper>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            className={classes.gridItemVertical}
                          >
                            <Paper className={classes.paper}>
                              <span className={classes.valueNumber}>
                                {
                                  data.partnerDetail.deviceCount
                                    .assignedToClientDevices
                                }
                              </span>
                              <br />
                              <span>
                                Assigned Devices <br />
                              </span>
                            </Paper>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            className={classes.gridItemVertical}
                          >
                            <Paper className={classes.paper}>
                              <span className={classes.valueNumber}>
                                {
                                  data.partnerDetail.deviceCount
                                    .registeredDevices
                                }
                              </span>
                              <br />
                              <span>Registered Devices</span>
                            </Paper>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            className={classes.gridItemVertical}
                          >
                            <Paper className={classes.paper}>
                              <span className={classes.valueNumber}>
                                {data.partnerDetail.deviceCount.inStockDevices}
                              </span>
                              <br />
                              <span>Unregistered Devices</span>
                            </Paper>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={2}
                        className={classes.gridItemHorizontal}
                        style={{
                          paddingRight: '15px'
                        }}
                      >
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            className={classes.gridItemVertical}
                          >
                            <Paper className={classes.paper}>
                              <span className={classes.valueNumber}>
                                {data.partnerDetail.simCount.totalSims}
                              </span>
                              <br />
                              <span>Total Sims</span>
                            </Paper>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            className={classes.gridItemVertical}
                          >
                            <Paper className={classes.paper}>
                              <span className={classes.valueNumber}>
                                {
                                  data.partnerDetail.simCount
                                    .assignedToClientSims
                                }
                              </span>
                              <br />
                              <span>
                                Assigned Sims <br />
                              </span>
                            </Paper>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            className={classes.gridItemVertical}
                          >
                            <Paper className={classes.paper}>
                              <span className={classes.valueNumber}>
                                {data.partnerDetail.simCount.registeredSims}
                              </span>
                              <br />
                              <span>Registered Sims</span>
                            </Paper>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            className={classes.gridItemVertical}
                          >
                            <Paper className={classes.paper}>
                              <span className={classes.valueNumber}>
                                {data.partnerDetail.simCount.inStockSims}
                              </span>
                              <br />
                              <span>Unregistered Sims</span>
                            </Paper>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid container className={classes.containerPadding}>
                        <Grid item xs={12} className={classes.gridItemVertical}>
                          <Subscriptions
                            partnerLoginId={parseInt(
                              this.props.match.params.loginId,
                              10
                            )}
                          />
                          <Grid
                            container
                            className={classes.containerPadding}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Fragment>
          )
        }}
      </Query>
    )
  }
}

PartnerView.propTypes = {
  classes: PropTypes.object.isRequired
}

const WrappedPartnerView = withApollo(withStyles(styles)(PartnerView))

export default props => (
  <Switch>
    {/* <PrivateRoute
      exact
      path="/home/partner/view/:loginId/add-subscription"
      render={() => <SubscriptionForm {...props} />}
    /> */}

    <PrivateRoute
      exact
      path="/home/partner/view/:loginId/edit-subscription"
      render={() => <SubscriptionForm {...props} />}
    />

    <PrivateRoute
      path="/home/partner/view/:loginId"
      render={() => <WrappedPartnerView {...props} />}
    />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/components/Pages/Partner/PartnerView.jsx